import { ColumnOptionsBase, ServerSideColumnOption } from '../types/column-options';
import { AmountColumn, NumberColumn, QuantityColumn } from '../types/grid';
import { EntityColumnRef, GridRef, GroupColumnRef } from '../types/refs';

export interface QuantityColumnOptions<TRow extends object> extends ColumnOptionsBase<TRow, number> {
  getUnit: (row: TRow | undefined) => string | undefined;
  format?: string;
  rowGroup?: boolean;
  aggFunc?: string;
}
export type ServerSideQuantityColumnOptions<TRow extends object> = QuantityColumnOptions<TRow> & ServerSideColumnOption;

export function quantityColumn<TRow extends object>(ref: GridRef<TRow> | GroupColumnRef<TRow> | EntityColumnRef<TRow>,
                                                  options: QuantityColumnOptions<TRow> | ServerSideQuantityColumnOptions<TRow>): QuantityColumn<TRow> {
  const column: QuantityColumn<TRow> = {
    ...options,
    type: 'quantity',
    format: options.format ?? 'NUMBER.DEFAULT'
  }
  ref.createColumn(column);
  return column;
}
